import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={21}
    height={22}
    viewBox="0 0 21 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.2545 1.20984C10.2872 1.09984 10.3886 1.02393 10.5036 1.02393C10.6186 1.02393 10.7199 1.09984 10.7527 1.20984C10.7527 1.20984 11.2086 2.73809 11.6973 4.37726C12.4759 6.98874 14.5187 9.03156 17.1302 9.81022C18.7694 10.2989 20.2976 10.7548 20.2976 10.7548C20.4076 10.7875 20.4835 10.8889 20.4835 11.0039C20.4835 11.1189 20.4076 11.2203 20.2976 11.253C20.2976 11.253 18.7694 11.7089 17.1302 12.1976C14.5187 12.9763 12.4759 15.0191 11.6973 17.6306C11.2086 19.2697 10.7527 20.798 10.7527 20.798C10.7199 20.908 10.6186 20.9839 10.5036 20.9839C10.3886 20.9839 10.2872 20.908 10.2545 20.798C10.2545 20.798 9.79854 19.2697 9.30987 17.6306C8.53121 15.0191 6.48838 12.9763 3.87691 12.1976C2.23775 11.7089 0.709498 11.253 0.709498 11.253C0.599491 11.2203 0.523582 11.1189 0.523582 11.0039C0.523582 10.8889 0.599491 10.7875 0.709498 10.7548C0.709498 10.7548 2.23775 10.2989 3.87691 9.81022C6.48838 9.03156 8.53121 6.98874 9.30987 4.37726C9.79854 2.73809 10.2545 1.20984 10.2545 1.20984Z"
      fill="url(#paint0_linear_4392_838)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_4392_838"
        x1={20.4835}
        y1={20.9839}
        x2={0.523577}
        y2={1.02393}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#223E76" />
        <stop offset={0.511069} stopColor="#365699" />
        <stop offset={1} stopColor="#2BA9B4" />
      </linearGradient>
    </defs>
  </svg>
);
export default SVGComponent;
